import { createSelector } from "reselect";

export const getUi = state => state.ui;

export const getLocale = createSelector(getUi, ui => ui.locale);

export const getListView = createSelector(getUi, ui => window.innerWidth > 768 && ui.listView);
